import _extends from "@babel/runtime/helpers/extends";
import { Stack } from '@mui/material';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
export default function CircularProgressWithLabel(props) {
    var _a;
    var title = props.title, count = props.count, total = props.total, value = props.value;
    return /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        gap: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "medium",
        color: "text.secondary"
    }, title, /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(Typography, {
        display: "inline-block",
        fontSize: "xxl",
        fontWeight: "medium",
        color: "primary.main"
    }, count), " / ", total), /*#__PURE__*/ React.createElement(Stack, {
        display: "inline-flex",
        position: "relative",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ React.createElement(CircularProgress, _extends({
        variant: "determinate",
        thickness: 6,
        size: 42,
        value: value,
        sx: (_a = {},
            _a["& .".concat(circularProgressClasses.circle)] = {
                strokeLinecap: 'round'
            },
            _a.rotate = '90deg',
            _a)
    }, props)), /*#__PURE__*/ React.createElement(Typography, {
        color: "text.secondary",
        fontSize: "xs",
        position: "absolute"
    }, "".concat(value, "%"))));
}
